module.exports = __webpack_public_path__ + "img/lxr.9079d1ce.png";